module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("1. BERGORT—WINTER 2011")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E’RE MOVING LOW ")]), _vm._v("to the ground through Bergort at night, our momentum perfectly calibrated, our formation solid and compact. We’re silent, our eyes pinpricks or dashes. We’re the X-Men, Band of Brothers, the elite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A car is burning on Drivvedsvägen, and we hear the windshield exploding from heat, see the glass shatter across the snow like ice, translucent shards of frustration and pleasure. This is just like every other night this winter, except the kids don’t even bother to run up onto the pedestrian bridge over the train tracks anymore. They stand so close the flames are reflected in their wide eyes, and their skin ends up singed. They know exactly how long it takes for the sirens to go off. They’re in no rush, have no deadlines to meet, don’t even have anything to run from anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But we don’t stop, we have a greater goal, we’re not just kids setting cars on fire anymore. We’re eagles and falcons, predators with razor-sharp claws, pointed teeth, and big appetites. Lois, Räven, Mehdi, and Bounty. I turn my head and see my brothers—shadows in the glow of the fire—and something in my heart expands. I have stopped chasing you. You started to leave all this a long time ago. And even though your shadow still falls across the gray walls of our room every night as I lie in my bed, it’s my friends—my brothers—who are like me. Lost and clueless. Empty and tired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Ey")]), _vm._v(", Fadi?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Bounty’s voice is high and hollow, as if he’s not getting enough air in his lungs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up, faggot,” Räven hisses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gives him a nudge on the shoulder, pushing Bounty into the deeper snow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop it,” I say. “This is serious now, got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But . . .” Bounty says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No fucking buts, "), _c('i', [_vm._v("sharmuta")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Räven hisses again and raises his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you’re sure about the door code?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bounty continues while taking a step backward to elude the blow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re sure they didn’t change it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The concrete looms over us, enclosing us, holding us fast. The air is cold and smells like burning gas. I shrug, feel my lungs tighten. Feel what I always do: I don’t know anything, am never sure of anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, damn it,” I say. “So shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "image01"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We wait in the shadows on the other side of Pirate Square even though it’s empty, even though it’s one-thirty in the morning. We wait until we hear the sirens cut across the highway, wait until we see the sky above the playground illuminated by blue lights. Wait until we see Mehdi trudging across the icy flagstones outside Sami’s kebab shop, his steps muffled thuds in the winter darkness. The sirens are gone now, the only sound kids screaming on their way across the footbridge in the opposite direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All clear,” Mehdi pants, his lungs whistling with asthma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leans forward, groaning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only the fire department, they don’t even send the police anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We all nod in silence, as solemn as a funeral. This is serious now. The key burns in my pocket, the code in my memory. I bend backward and let my eyes drift toward the other side of the square and then up—to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("the windows covered with the sticky handprints of children, the cracked facade, the tangled blinds, the bedsheet curtains, the satellite dishes, the Somalian flags, and then up to the roof and beyond. The sky is black and cold, and not even the stars are out tonight, not even a sad sliver of a moon, just empty, black clouds, and nothing. Still, I let my eyes rest there, as frozen as my fingers and the night. This is the real choice. You or my brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I force my eyes away from the sky, like pulling a tongue from a frozen flagpole, and say:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you waiting for? "), _c('i', [_vm._v("Jalla")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We rush in formation across the square, as stealthy as fucking drones. We’re a unit, we’re gangsters, we’re elite. We make no sound, only smoke comes from our mouths, just breath and blood rushing in our ears, just us and our mission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s easy. Punch in the front door code, don’t even look over my shoulder. Everybody in, and then I do what I’ve seen you do—head straight for the white keypad, my heart beating, punch in the code and see "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FROM")]), _vm._v(" on the display, only a thousandth of a second wait for the long beep that means it’s worked, and we’re inside. Fast high fives, silence, flashlights on, and down the hall into the studio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two MacBooks on the table in the mixing room. "), _c('i', [_vm._v("Swoosh! ")]), _vm._v("Ours now. Two Samsungs charging. "), _c('i', [_vm._v("Swoosh! ")]), _vm._v("Ours now. Three small tablets. "), _c('i', [_vm._v("Swoosh! ")]), _vm._v("Mics and guitars. We look at each other. Fuck it. Too heavy. I bend down over the mixing table, squatting, groping in the darkness until I find it. Slowly I pull out the Nike shoe box. Open it, bend my face in closer, and let the sweet smell of weed wash over me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Ey!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hold up a joint for the brothers, whose eyes widen as they give me the thumbs-up. But there’s more. I saw it when I was here with you, saw Blackeye take two thousand and give it to some fucking hanger-on to buy liquor. That’s when this first occurred to me, when the idea was born.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sneak into the other room, the office. Pull on the top drawer, but it’s locked. Jackpot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("“Räven!” I whisper into the studio. “Screwdriver.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Räven is the king of the screwdriver, chisel, and crowbar. There’s no window, no door he can’t open—so this is easy. He braces himself against the desktop and bends over and the drawer jumps up and out. The cash box is green and heavy, and I stop Räven from prying it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fuck it,” I say. “We’ll do that later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then it’s over. We run out the door like water, our hands full of loot, down toward the playground, where we divide it roughly. I’ll take the cash box and a MacBook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lie low. See you Thursday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then it’s over. The night is cold and empty and quiet. Not even the cars are burning anymore and exhaustion washes over me like an ocean, like snow, like darkness, and I stagger home, quiet and empty, not at all like I expected.")]), _vm._v(" "), _c('p', {
    staticClass: "image01"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In my room the grayish-yellow light of the streetlamp outside my window won’t let go of me. It finds its way under my eyelids and into my pupils, even when I close my eyes and burrow my head into my lumpy pillow. No matter what I do, it won’t let me sleep. Finally, I give up, open my eyes, and sit up in bed, but I don’t turn on the lamp. Time slows down and changes shape until it finally stops completely, and I hear the door to my room creak, the floor squeak. I don’t turn, just keep my eyes on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You bring the winter into my room with you and sit at the bottom of my bed. The air stands still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember when we were little?” you begin. “You must have been around ten or so? Remember when I started to say I had to get away from here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know what you’re going to tell me, it’s one of our stories, part of our mythology, but I say nothing. Just sit there, empty, with my back straight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d had another fight with them. Don’t remember what it was about. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("Someone "), _c('i', [_vm._v("khara")]), _vm._v(", some bullshit, who knows? And I ran out, didn’t come home until late. And you were too big to play with your dirty old thrift store LEGOs? But when I came home, you’d put all your blue pieces on one of those green plates, some white here and there, and placed it on my bed before you went to bed. Do you remember?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod weakly. I remember. I remember everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember what you’d made?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t say anything. It was too long ago. Too much has happened since then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said it was an ocean. That you’d built us an ocean to sail away on. And you were going to build a boat for us to sail away on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I feel it burning behind my eyelids and in my chest. I feel it all crashing down, drowning in the past, drowning in the future. You don’t need water to drown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you never built that boat, Fadi, just the ocean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to say something, try to explain, beg you to forgive me, forgive me, forgive me. But I know that all I can do is whimper, all I do is cause chaos and stress. We sit in silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, finally:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you’ve finally made that boat, Fadi,” you say. “But it’s only big enough for one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I finally turn and look at you. You are tired and thin, your skin pale in the dim light. I knew you were on your way somewhere else since I was little. But I’ve never seen you like this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You look so sad when you look at me. Not disappointed, not angry. Just sad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did you think? They wouldn’t figure out whose code was used? Everybody has their own code to the studio. So you always know who’s been there and when. That’s the first thing Jorge will check tomorrow, and he’ll see my code was used, won’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What should I do? Shame burns inside me. Betrayal. My fucking stupidity. I’m a "), _c('i', [_vm._v("khain")]), _vm._v("—a traitor. Then comes the terror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“Jorge and Blackeye,” I say. “They’re gonna kill me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not them,” you say. “But Biz or Mahmud or the Russian probably will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I feel the tears running down my cheeks. The tears are shameful, of course, but the fear paralyzes me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fadi,"), _c('i', [_vm._v(" habibi,")]), _vm._v("” you say. “How could you be so fucking stupid? You know they’re not gonna be content to just get their stuff back. Anybody who does something like this to the Pirate Tapes . . . Damnit, Fadi, it’s the only thing we have to be proud of. Whoever does something like this is a traitor. To Bergort. No one will lift a finger to stop them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through my tears, I see you stand up from the bed and go to your closet. You’re almost never here, just a few nights of the week, but I know you keep your sketchbooks here. Now you reach up for the top shelf, rummage around through notepads and books and drop them into a Pirate Tapes tote bag along with your Swedish dictionary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It feels so far away now, how we thought it would be enough to learn all those words. You stop, remove the dictionary, put it on the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s better if you take this,” you say. “I don’t need it anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hide my face with my hands, can’t see you anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did you know?” I say quietly. “How did you know about Pirate Tapes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glimpse through my hands how you shrug, how you shake your head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw you up on the bridge this afternoon, chain-smoking. You were obviously up to something. You’re not exactly smooth, Fadi. Then I heard about the burglary. I put it together. I’m not stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you going to do?” I say. “Where are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter. It’s better that you don’t know right now. I’ll contact you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You crouch down in front of me, force my hands away from my face, force me to look at you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here,” you say, and your voice is so severe it causes the air to tremble around us. “As far as they know I’m the one who was at the studio "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("last night. It’s my code. If I disappear into the night without a word, there’s no reason to suspect anyone else.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You hold my wrists, stare straight into my eyes, through my tears and shame, through the mirrors and smoke of my illusion, straight into who I am, straight to the bottom. I don’t know what to say. I open my mouth and close it, trying to turn away, but you won’t let me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I don’t understand,” I try.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s simple, "), _c('i', [_vm._v("habibi,")]), _vm._v("” you say. “In the end, you did build me a boat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You stroke my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forgive me,” I say. “Forgive me, forgive me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I close my eyes and feel your dry lips against my cheek. When I open my eyes again, you’re gone.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76a2e1bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062337290_Chapter_1.vue
// module id = 72
// module chunks = 0